<template>
  <q-tabs
    v-model="currentValue"
    :vertical="vertical"
    :dense="dense"
    active-color="primary"
    indicator-color="primary"
    :align="align"
    no-caps
    :inline-label="inlineLabel"
  >
    <slot v-if="$slots.default" />

    <template v-else>
      <q-tab
        :name="item.value"
        :label="item.label"
        :disable="item.disable"
        v-for="item in tabItems"
        :alert="item.notice ? 'red' : false"
        :key="item.label"
        :icon="item.icon"
        :class="item.class"
      />
    </template>
  </q-tabs>
</template>

<script>
/*
 * tabItems: [{value: String, label: String}]
 */

export default {
  name: 'Tab',
  props: {
    value: {
      type: String,
    },
    tabItems: {
      type: Array,
      required: true,
    },
    vertical: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    align: {
      type: String,
      default: 'left',
    },
    inlineLabel: {
      type: Boolean,
    },
  },
  computed: {
    currentValue: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>
